module.exports = __webpack_public_path__ + "img/icon3.a273fd7b.png";